import React from 'react';
import Grid from '@material-ui/core/Grid';
import { useFormikContext } from 'formik';

import useSession from 'core/hooks/use-session';
import { FormField } from 'core/components/form';
import { LabelTooltip } from 'core/components/label-tooltip';

const OTHER_PAYMENT_METHOD_LABEL = {
  B: 'Bill to other'
};

const StripeCustomerIdField = () => {
  const { canModifyBillingId } = useSession();
  const { values } = useFormikContext();
  if (!canModifyBillingId) {
    return false;
  }
  const otherStripeCustomers = Array.isArray(values?.otherStripeCustomers) ? values.otherStripeCustomers : [];
  return (
    <>
      <Grid item xs={4}>
        <LabelTooltip
          label="Billing ID"
          mode="dark"
          tooltip={{
            label: 'More Info',
            onHoverText:
              'The primary Stripe customer for this policy — typically the policyholder. Charges, mandates, and payment-method updates target this customer.'
          }}
        >
          <FormField name="stripeCustomerId" type="string" mode="dark" />
        </LabelTooltip>
      </Grid>
      {otherStripeCustomers.map((customer, index) => {
        const methodLabel = OTHER_PAYMENT_METHOD_LABEL[customer.paymentMethod] || customer.paymentMethod;
        const label = customer.active ? `${methodLabel} Billing ID (Active)` : `${methodLabel} Billing ID`;
        return (
          <Grid item xs={4} key={`${customer.stripeId}-${index}`}>
            <LabelTooltip
              label={label}
              mode="dark"
              tooltip={{
                label: 'More Info',
                onHoverText: `Stripe customer for the ${methodLabel.toLowerCase()} payer. Used at bind for the one-time charge — not modifiable in V1.`
              }}
            >
              <FormField name={`otherStripeCustomers[${index}].stripeId`} type="string" mode="dark" disabled />
            </LabelTooltip>
          </Grid>
        );
      })}
    </>
  );
};

export default StripeCustomerIdField;
